/**
 * Lightweight arithmetic captcha used on public auth forms
 * (sign in, sign up, password reset) to slow down automated submissions.
 */
export interface Captcha {
  question: string;
  answer: number;
}

function randomDigit(): number {
  return Math.floor(Math.random() * 9) + 1;
}

export function createCaptcha(): Captcha {
  const a = randomDigit();
  const b = randomDigit();
  return { question: `${a} + ${b} = ?`, answer: a + b };
}

export function captchaMatches(captcha: Captcha, value: unknown): boolean {
  return Number.parseInt(String(value ?? '').trim(), 10) === captcha.answer;
}
